<template>
<div class="chapter">
<div class="inner_page">
<a id="p4"></a>
<p class="sink"> </p>
<p class="left "><em>The Fortunes</em> is a work of fiction. As such, the book should not be read as a factual account of events or as biography. While the novel touches on real figures in Chinese American history, their thoughts, motives, and actions have been imagined by the author and should be considered as products of the imagination.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front04.vue?7f62a514